import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'
//-------------------------------------------- New
export const getProjectBudget = (projectVersionId) => {
  // http://103.91.191.229:9000/api/proposal/{projectId}/project/budget
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget`
  // const url = `${API_ROOT}/proposal/${projectVersionId}/budget/except/operatorcost`
  return doGet(url)
}

export const getProjectBudgetExcept = (projectVersionId) => {
  // /api/proposal/{projectVersionId}/budget/except/operatorcost
  const url = `${API_ROOT}/proposal/${projectVersionId}/budget/except/operatorcost`
  return doGet(url)
}

export const saveProjectBudget = (projectVersionId, request) => {
  // http://103.91.191.229:9000/api/proposal/{projectVersionId}/project/budget/{categoryId}

  // const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget/${request.categoryId}`

  const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget/${request.categoryId}`
  return doPost(url, request)
}

export const updateProjectBudget = (projectVersionId, request) => {
  // http://103.91.191.229:9000/api/proposal/{projectVersionId}/project/budget/{categoryId}/{costId}
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget/${request.categoryId}/${request.id}`
  return doPut(url, request)
}

export const deleteProjectBudget = (projectVersionId, categoryId, id) => {
  // /api/proposal/{projectVersionId}/project/budget/{categoryId}/{costId}
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget/${categoryId}/${id}`
  return doDelete(url)
}

export const getProjectBudgetRefresh = (projectVersionId, categoryId) => {
  // http://103.91.191.229:9000/api/proposal/{projectVersionId}/project/budget/{categoryId}
  const url = `${API_ROOT}/proposal/${projectVersionId}/project/budget/${categoryId}`
  return doGet(url)
}
//--------------------------------------------

//BudgetFrom
export const getBudget = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget`
  return doGet(url)
}

//Activity
export const getActivity = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity`
  return doGet(url)
}

export const saveActivity = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity`
  return doPost(url, request)
}

export const updateActivity = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${request.id}`
  return doPut(url, request)
}

export const deleteActivity = (id, activityId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}`
  return doDelete(url)
}

//Category
export const getBudgetCategory = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/category`
  return doGet(url)
}

export const getBudgetCategoryByCategoryId = (projectVersionId, categoryId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/budget/category/${categoryId}`
  return doGet(url)
}

export const saveBudgetCategory = (request, projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/budget/category/${request.categoryId}`
  return doPost(url, request)
}

export const updateBudgetCategory = (request, projectVersionId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/budget/category/${request.categoryId}/${request.id}`
  return doPut(url, request)
}

export const deleteBudgetCategory = (projectVersionId, categoryId, costId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/budget/category/${categoryId}/${costId}`
  return doDelete(url)
}

//Activity Cost
export const getActivityCost = (id, activityId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/cost`
  return doGet(url)
}

export const saveActivityCost = (id, activityId, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/cost`
  return doPost(url, request)
}

export const updateActivityCost = (id, activityId, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/cost/${request.id}`
  return doPut(url, request)
}

export const deleteActivityCost = (id, activityId, costId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/cost/${costId}`
  return doDelete(url)
}

//Activity Product
export const getActivityProduct = (id, activityId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/product`
  return doGet(url)
}

export const saveActivityProduct = (id, activityId, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/product`
  return doPost(url, request)
}

export const updateActivityProduct = (id, activityId, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/product/${request.id}`
  return doPut(url, request)
}

export const deleteActivityProduct = (id, activityId, productId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/activity/${activityId}/product/${productId}`
  return doDelete(url)
}

//Equipment
export const getEquipment = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/equipment`
  return doGet(url)
}

export const saveEquipment = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/equipment`
  return doPost(url, request)
}

export const updateEquipment = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/equipment/${request.id}`
  return doPut(url, request)
}

export const deleteEquipment = (id, equipmentId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/equipment/${equipmentId}`
  return doDelete(url)
}

//InstitutionalFee
export const getInstitutionalFee = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/institutional-fee`
  return doGet(url)
}

export const saveInstitutionalFee = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/institutional-fee`
  return doPost(url, request)
}

export const updateInstitutionalFee = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/institutional-fee/${request.id}`
  return doPut(url, request)
}

export const deleteInstitutionalFee = (id, institutionalFfeeId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/institutional-fee/${institutionalFfeeId}`
  return doDelete(url)
}

//Participant
export const getParticipant = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/participant`
  return doGet(url)
}

export const saveParticipant = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/participant`
  return doPost(url, request)
}

export const updateParticipant = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/participant/${request.id}`
  return doPut(url, request)
}

export const deleteParticipant = (id, participantId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/participant/${participantId}`
  return doDelete(url)
}

//OtherSupport
export const getOtherSupport = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other-support`
  return doGet(url)
}

export const saveOtherSupport = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other-support`
  return doPost(url, request)
}

export const updateOtherSupport = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other-support/${request.id}`
  return doPut(url, request)
}

export const deleteOtherSupport = (id, otherSupportId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other-support/${otherSupportId}`
  return doDelete(url)
}

//Summary
export const getSummary = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/summary`
  return doGet(url)
}

//Other
export const getOther = (id) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other`
  return doGet(url)
}

export const saveOther = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other`
  return doPost(url, request)
}

export const updateOther = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other/${request.id}`
  return doPut(url, request)
}

export const deleteOther = (id, otherId) => {
  const url = `${API_ROOT}/proposal/${id}/budget/other/${otherId}`
  return doDelete(url)
}

//checkStatusProjectActivity
export const checkStatusProjectActivity = (projectVersionId, activityId, activityCostId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/checkStatusProjectActivity?activityId=${
    activityId || ''
  }&activityCostId=${activityCostId || ''}`
  return doGet(url)
}

//checkStatusProjectActivity Main Activity
export const checkStatusProjectActivityMain = (projectVersionId, activityId, activityCostId) => {
  const url = `${API_ROOT}/proposal/${projectVersionId}/checkStatusProjectActivityMain?activityId=${
    activityId || ''
  }`
  return doGet(url)
}

